import { CampaignsListUi, type ICampaignsListUiProps } from './ui/CampaignsListUi'
import { CampaignsListContext } from './context/context'
import { type CampaignsListStore } from './store/CampaignsListStore'

type ICampaignsListProps = {
  store: CampaignsListStore
} & ICampaignsListUiProps

export const CampaignsList = ({ store, ...props }: ICampaignsListProps) => {
  return (
    <CampaignsListContext.Provider value={store}>
      <CampaignsListUi {...props} />
    </CampaignsListContext.Provider>
  )
}
